import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { Check, Copy, Loader2, Save } from 'lucide-react';
import { NoteMoreMenu } from './NoteMoreMenu';
import { noteToolbarClasses } from './noteInstructions.styles';
import type { NoteToolbarActionsProps, NoteToolbarProps } from './noteInstructions.types';

const NoteSaveCopy = ({ onSave, isSaving, copied, onCopy }: NoteToolbarActionsProps) => (
  <>
    {onSave && (
      <Button
        size="sm"
        variant="ghost"
        onClick={onSave}
        disabled={isSaving}
        className="h-8 gap-1 text-primary hover:bg-primary/5 hover:text-primary"
      >
        {isSaving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />}
        Vista
      </Button>
    )}
    <Button
      size="sm"
      variant="outline"
      className={cn('ml-1 h-8 shrink-0 gap-1', copied && 'text-green-600 hover:text-green-600')}
      onClick={onCopy}
    >
      {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
      {copied ? 'Afritað' : 'Afrita'}
    </Button>
  </>
);

/** The composer panel's one row above the note: template, review, ⋯ and Afrita. */
export const NoteToolbar = ({ template, review, menu, actions }: NoteToolbarProps) => (
  <div data-testid="note-toolbar" className={noteToolbarClasses}>
    <div className="flex min-w-0 flex-1">{template}</div>
    {review}
    {menu && <NoteMoreMenu {...menu} />}
    {actions && <NoteSaveCopy {...actions} />}
  </div>
);
